export default "__VITE_ASSET__C29KEipk__"